import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static classes = ['open', 'closed', 'collapse']

  toggle (event) {
    event.preventDefault()
    const li = event.currentTarget.parentElement.parentElement
    const icon = event.currentTarget.firstElementChild

    li.classList.toggle(this.collapseClass)
    icon.classList.toggle(this.closedClass)
    icon.classList.toggle(this.openClass)
  }
}
